import { red } from '@mui/material/colors';
import { createTheme } from '@mui/material/styles';

//
// A MUI theme for the app.
// What's possible should be customized here.
// Other styling is done in `base.sass` and `app.sass`.
//

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#8c4ed8',
    },
    secondary: {
      main: '#3a60bc',
      // light: '#***',
      // dark: '#***',  // for hover on light theme
      // contrastText: '#***',   // for text
    },
    text: {
      primary: 'rgb(29, 48, 93)',
    },
    // for messages
    info: {
      main: '#5a63ce',
      main2: '#5a63ce',
    },
    warning: {
      main: '#ffa636',
    },
    success: {
      main: '#58a658',
    },
    error: {
      main: '#e32e2e',
    },
  },
  shape: {
    borderRadius: 15,  // buttons and boxes
  },

  custom: {
    spinnerDelay: 500,  // milliseconds
    appBarHeight: {
      xs: '56px',
      sm: '64px',
    },
    roughHeightBelowBar: {
      xs: 'calc(100vh - 56px - 24px*2)',  // FIXME: 24px is some default
      sm: 'calc(100vh - 64px - 24px*2)',
    },
    //
    dev: {
      appBar: {
        background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent)',
        backgroundSize: '20px 20px',
      }
    },
    stage: {
      appBar: {
        background: 'linear-gradient(45deg, rgba(255, 255, 255, 0.2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.2) 50%, rgba(255, 255, 255, 0.2) 75%, transparent 75%, transparent)',
        backgroundSize: '20px 20px',
      }
    }
  },

  //
  // This affects multi-line headers,
  // e.g. in Risks and Plan views.
  //
  typography: {
    h1: { },
    h2: { },
    h3: {
      lineHeight: '0.9',  // main view header
      paddingBottom: '15px',
    },
    h4: {
      lineHeight: '1.1',
    },
    h5: {
      lineHeight: '1.13',  // 1.13 seems visually good for multiline header
    },
    h6: {
      lineHeight: '1.25',  // 1.25 seems visually good for multiline header
    },
  },


  components: {
    // Palette doesn't support gradients (according to GPT4), so apply to components directly
    MuiButton: {
      styleOverrides: {
        containedPrimary: { // Targeting the primary contained buttons
          background: 'linear-gradient(45deg, #9d59f1 30%, #0be3be 90%)',
          color: 'white',
          '&:hover': {
            // a similar or slightly different gradient for the hover state
            background: 'linear-gradient(45deg, #9d59f1 60%, #0be3be 100%)',
          },
          '&:disabled': {
            color: 'lightgrey',
            background: 'linear-gradient(45deg, #caaaf2 60%, #9fe3d8 90%)',
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          background: 'linear-gradient(45deg, #9d59f1 30%, #0be3be 90%)',
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          backgroundColor: '#703ead',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          // Get rid of annoying missing right padding on all screens.
          padding: '0 24px 0 24px!important',
        },
      },
    },
  },
});

export default theme;
